module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="headerCommunityFlyout__wrap__headerSearchTextField">\n    <div class="js-search-field headerSearchTextField"></div>\n</div>\n\n<div class="js-content-default"></div>\n\n<div class="js-content-search is-hidden"></div>\n\n<div class="js-more-communities"></div>\n';
}
return __p;
};
